// extracted by mini-css-extract-plugin
module.exports = {"root":"Alert_root__vlp2S","is-error":"Alert_is-error__NmOVD","is-info":"Alert_is-info__Ppa4q","is-warning":"Alert_is-warning__DFMzw"};